import { getUserName } from "../../../helpers";
import ProfileImageComp from "../../common/profile";
import { Link } from "react-router-dom";
import { useLazyGetUserPercentileQuery } from "../../../store/api/leaderboardApi";
import { ROUTES } from "../../../constants/routes";
import { useGetHomeDataQuery } from "../../../store/api/homeApi";
import { useLazyGetLastWatchedEpisodeQuery } from "../../../store/api/academyApi";
import { useEffect, useState } from "react";
import moment from "moment";
import { useLazyGetUserBadgesQuery } from "../../../store/api/userApi";
import { PlayButton } from "../../../icons";
import { ProgressCircularBar } from "../../../icons/academy-icons";
import ProfileBadgeAvatar from "../../user/user-profile/profile-avatar";
import { VerifiedBadgeIcon } from "../../../icons/badge-icons";

const Profile = () => {
  const { data: userData } = useGetHomeDataQuery("", {
    refetchOnFocus: false,
    refetchOnMountOrArgChange: false,
  });
  const { user, account_balances } = userData?.data || {};
  const [getUserPercentile] = useLazyGetUserPercentileQuery();
  const [getLastWatchedEpisode] = useLazyGetLastWatchedEpisodeQuery();
  const [lastWatchedEpisode, setLastWatchedEpisode] = useState<any>(null);
  const [badges, setBadges] = useState<any>([]);
  const [getBadges] = useLazyGetUserBadgesQuery({ userId: user?._id });
  const [percentileData, setPercentileData] = useState<any>(null);

  const fetchLastWatchedEpisode = async () => {
    try {
      const response = await getLastWatchedEpisode()?.unwrap();
      if (response?.success && !response.data.message) {
        setLastWatchedEpisode(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchPercentileData = async () => {
    try {
      const response = await getUserPercentile("xp")?.unwrap();
      if (response?.success) {
        setPercentileData(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchBadges = async () => {
    if (!user) return;
    try {
      const response = await getBadges({ userId: user?._id })?.unwrap();
      if (response?.success) {
        setBadges(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (user && user?.is_onboarded) {
      fetchPercentileData();
    }
  }, [user]);

  useEffect(() => {
    Promise.all([fetchLastWatchedEpisode(), fetchBadges()]);
  }, [user]);

  const gridOverlayStyle = {
    background: "rgba(0, 0, 0, 0.3)",
  };

  return (
    <div className="lg:col-span-3 bg-white rounded-[12px] border max-h-[685px] h-fit">
      <div className="h-14 bg-blue-200 relative rounded-t-[10px]">
        {user?.banner && (
          <img
            src={user?.banner}
            alt="Background"
            className="w-full h-full rounded-t-[10px] object-cover"
          />
        )}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
          <Link to={ROUTES.USER_PROFILE.replace(":user_id", user?._id)}>
            {user?.badge ? (
              <div className={`relative w-16 h-[64px] mr-2`}>
                <ProfileBadgeAvatar
                  profileImage={user?.profile_picture}
                  customDivClassName="absolute h-16 w-16 border-4 z-1"
                  customImgClassName="h-[64px] w-[64px] absolute rounded-full p-1"
                  customIconDivClassName="absolute z-[120] -bottom-1.5 left-[24px]"
                  customStyle1="w-[50px] h-5 absolute -bottom-2 z-[100] overflow-hidden"
                  customStyle2="w-[200px] h-6 absolute top-5 z-10 -left-10 overflow-hidden"
                  customStarWidth={16}
                  customStarHeight={16}
                  customStyle3="w-[56px] h-[56px]"
                  badge={user?.badge}
                />
              </div>
            ) : (
              <ProfileImageComp
                imageUrl={user?.profile_picture}
                customClass="h-[69px] w-[69px]"
                is_opc={user?.memberships?.is_opc}
              />
            )}
          </Link>
        </div>
      </div>
      <div className="flex flex-col items-center space-y-2 py-5 mt-4">
        <div className="text-center">
          <div className="text-lg font-semibold text-gray-900 flex items-center">
            {getUserName(user)}
            {user?.is_verified && (
              <div className="ml-2">
                <VerifiedBadgeIcon width={20} height={21} />
              </div>
            )}
          </div>
          <p className="text-sm text-gray-500">{user?.designation}</p>
        </div>
        <div className="flex space-x-2 mt-1 justify-center">
          <div className="flex items-center text-gray-600 text-sm">
            <div className="flex items-center space-x-1 bg-primary-600 p-1 px-2 rounded-full border border-solid border-primary-200">
              <img
                src="/assets/logo/OneGoldCoin.png"
                alt=""
                className="w-4 h-4"
              />
              <span className="ml-1 text-gray-700">
                {account_balances?.coins || 0}
              </span>
            </div>
          </div>
          <div className="flex items-center text-gray-600 text-sm">
            <div className="flex items-center space-x-1 bg-primary-600 p-1 px-2 rounded-full border border-solid border-primary-200">
              <img
                src="/assets/icons/star-red.png"
                alt=""
                className="w-4 h-4"
              />
              <span className="ml-1 text-gray-700">
                {account_balances?.xp || 0}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex py-2 text-center ">
        <div className="border-r border-gray-300 text-center flex-1 ">
          <p className="text-[13px] text-gray-500">Posts</p>
          <p className="text-[15px] font-semibold text-gray-900">
            {user?.network?.posts || 0}
          </p>
        </div>
        <div className="border-r border-gray-300 text-center flex-1 ">
          <p className="text-[13px] text-gray-500">Followers</p>
          <p className="text-[15px] font-semibold text-gray-900">
            {user?.network?.followers || 0}
          </p>
        </div>
        <div className=" text-center flex-1 ">
          <p className="text-[13px] text-gray-500">Following</p>
          <p className="text-[15px]  font-semibold text-gray-900">
            {user?.network?.following || 0}
          </p>
        </div>
      </div>
      {/* Achievements */}
      {badges.length > 0 && (
        <div className="mt-3 px-6 py-2  border-t">
          <h3 className="text-[17px] font-semibold">Achievements</h3>
          <p className="text-gray-500 text-[13px] mt-2 mb-3">Badges Earned</p>
          <div className="flex gap-2 overflow-x-scroll whitespace-nowrap">
            {badges.map((badge: any, index: number) => (
              <img
                key={index}
                src={badge.badge_icon}
                alt="Achievement"
                className="w-14 h-14"
              />
            ))}
          </div>
        </div>
      )}

      {/* Current Module */}
      {lastWatchedEpisode && (
        <div className="mt-2 p-4 border-t">
          <Link
            to={`/academy/courses/${lastWatchedEpisode.course_id}/${lastWatchedEpisode.module_id}/${lastWatchedEpisode.episode_id}`}
          >
            <h3 className="text-[17px] font-semibold mb-3">
              Pick where you left
            </h3>
            <div className="flex items-center border rounded-lg">
              <div className="relative w-28 h-[72px]">
                <img
                  src={lastWatchedEpisode.module_thumbnail}
                  alt="Module thumbnail"
                  className="absolute inset-0 w-full h-full rounded-l-lg object-cover"
                />
                <div
                  className="absolute inset-0 rounded-l-lg"
                  style={gridOverlayStyle}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="relative">
                    <ProgressCircularBar
                      radius={14}
                      completion_percentage={45}
                      backRingColor="transparent"
                      customStyle="absolute -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 w-12 h-12"
                      strokeWidth={4}
                    />
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-9 h-9 bg-black rounded-full flex items-center justify-center">
                      <div className="ml-1">
                        <PlayButton />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ml-4">
                <p className="text-gray-500 text-[13px]">
                  Module {lastWatchedEpisode.module_number} •{" "}
                  {moment()
                    .date(lastWatchedEpisode.episode_number || 1)
                    .format("Do")}{" "}
                  Episode
                </p>
                <p className="font-semibold text-[15px]">
                  {lastWatchedEpisode.title.length > 47
                    ? `${lastWatchedEpisode.title.substring(0, 47)}...`
                    : lastWatchedEpisode.title}
                </p>
              </div>
            </div>
          </Link>
        </div>
      )}
      {percentileData && (
        <div className="p-4 mt-2 border-t border-t-solid border-t-primary-600">
          <Link to={"/leaderboard"}>
            <h2 className="text-lg font-medium text-primary-900 ">
              Leaderboard Score
            </h2>
          </Link>
          <div className="flex items-center justify-between mt-2">
            <div className="flex items-center">
              <div className="mr-2 text-sm text-black">
                {percentileData?.percentile + "%"}
              </div>
              <div>
                <div className="flex items-center space-x-2">
                  {user?.badge ? (
                    <div className={`relative w-10 h-[40px]`}>
                      <ProfileBadgeAvatar
                        profileImage={user?.profile_picture}
                        customDivClassName="absolute h-10 w-10 border-4 z-1"
                        customImgClassName="h-[40px] w-[40px] absolute rounded-full p-[3px] z-10"
                        customIconDivClassName="absolute z-[10] -bottom-[5px] left-[15px]"
                        customStyle1="w-[50px] h-[14px] absolute -bottom-2 z-[11] overflow-hidden"
                        customStyle2="w-[200px] h-4  absolute top-3 z-10 -left-10 overflow-hidden"
                        customStarWidth={10}
                        customStarHeight={10}
                        customStyle3="w-[34px] h-[34px]"
                        badge={user?.badge}
                      />
                    </div>
                  ) : (
                    <ProfileImageComp
                      imageUrl={user?.profile_picture}
                      customClass="h-10 w-10"
                      is_opc={user?.memberships?.is_opc}
                    />
                  )}
                  <div>
                    <div className="font-semibold text-primary-900">
                      {getUserName(user)}
                    </div>
                    <div className="text-fs-13 text-primary-800">You</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="font-semibold text-right text-gray-900">
                {account_balances?.xp || 0}
              </div>
              <div>
                <div className="flex items-center font-semibold text-gray-900 ">
                  <img
                    src="/assets/icons/star-red.png"
                    alt=""
                    className="w-4 h-4"
                  />
                  <div className="text-fs-11 text-primary-800 ml-1 mt-0.5">
                    XP
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
